import type { Theme } from '@jgp-er-dev/themes'
import pptxgen from 'pptxgenjs'

import {
  BASE_PLACEHOLDER_HEIGHT_IN,
  BASE_PLACEHOLDER_WIDTH_IN,
  IMAGE_GAP_IN,
  INITIAL_X_POSITION_IN,
  INITIAL_Y_POSITION_IN,
  MAIN_PAGE_TITLE,
  MONTHS_PT_BR,
  SLIDE_PAGE_TITLE,
} from './constants'

export const getMainPageMasterProps = (theme: Theme) =>
  ({
    title: MAIN_PAGE_TITLE,
    background: { fill: 'FFFFFF' },
    objects: [
      {
        image: {
          x: 0,
          y: 0,
          w: '100%',
          h: 5.46,
          data: theme.compass.presentation.darkBackgroundData,
        },
      },
      {
        text: {
          text: `${
            MONTHS_PT_BR[new Date().getMonth()]
          } ${new Date().getFullYear()}`,
          options: {
            x: 0.79,
            y: 5.91,
            w: 5.65,
            h: 0.34,
            fontSize: 19.7,
            fontFace: 'Founders Grotesk Light',
            color: theme.compass.presentation.titleDateColor,
          },
        },
      },
      {
        text: {
          text: theme.compass.presentation.disclaimerText,
          options: {
            x: 0.79,
            y: 6.37,
            w: 6.78,
            h: 0.27,
            fontSize: 8.6,
            fontFace: 'Founders Grotesk Light',
          },
        },
      },
      {
        placeholder: {
          options: {
            name: 'presentationTitle',
            type: 'title' as pptxgen.PLACEHOLDER_TYPES,
            x: 0.79,
            y: 2.27,
            w: 11.64,
            h: 3.18,
          },
        },
      },
    ],
  } as pptxgen.SlideMasterProps)

export const getSlidePageMasterProps = () =>
  ({
    title: SLIDE_PAGE_TITLE,
    background: { fill: 'FFFFFF' },
    objects: [
      {
        rect: {
          x: '5%',
          y: 0.54,
          w: '90%',
          h: 0,
          line: { color: '000000', size: 1 },
        },
      },
      {
        placeholder: {
          options: {
            name: 'subject',
            type: 'body' as pptxgen.PLACEHOLDER_TYPES,
            x: '60%',
            y: 0.18,
            w: '30%',
            h: 0.36,
            fontSize: 14.2,
            fontFace: 'Work Sans',
          },
          text: '',
        },
      },
      {
        placeholder: {
          options: {
            name: 'title',
            type: 'title' as pptxgen.PLACEHOLDER_TYPES,
            x: '5%',
            y: 0.8,
            w: '90%',
            h: 0.5,
            fontSize: 30,
            fontFace: 'Founders Grotesk Semibold',
          },
          text: '',
        },
      },
      {
        rect: {
          x: '5%',
          y: 1.4,
          w: '90%',
          h: 0,
          line: { color: '000000', size: 2 },
        },
      },
    ],
  } as pptxgen.SlideMasterProps)

const getPlaceholderHeight = (totalImages: number) =>
  totalImages <= 2 ? BASE_PLACEHOLDER_HEIGHT_IN : BASE_PLACEHOLDER_HEIGHT_IN / 2

const getPlaceholderWidth = (totalImages: number) =>
  totalImages === 1 ? BASE_PLACEHOLDER_WIDTH_IN : BASE_PLACEHOLDER_WIDTH_IN / 2

export const getPlaceholder = (itemNumber: number, totalImages: number) => {
  const width = getPlaceholderWidth(totalImages)
  const height = getPlaceholderHeight(totalImages)

  return {
    x: INITIAL_X_POSITION_IN + (itemNumber % 2) * (width + IMAGE_GAP_IN),
    y:
      INITIAL_Y_POSITION_IN +
      Math.floor(itemNumber / 2) * (height + IMAGE_GAP_IN),
    w: width,
    h: height,
  }
}
